export default __webpack_public_path__ + "static/media/daily.5b494f5f.svg";